import { Reward } from "@components/PointsDistribution-V2/Reward";
import { REWARDS_DISTRIBUTION_DATA } from "@constants/common";

const RewardsGridFallback = ({ dashboardData, isLoading }: any) => {
  return (
    <div className="bg-bg-card p-6 rounded-[16px] flex flex-col gap-6 w-full h-full">
      <h3 className="text-[16px] font-medium leading-6 text-text-primary">
        Your rewards from DeFi
      </h3>

      {isLoading ? (
        <div className="flex justify-center py-8">
          <div className="w-8 h-8 border-4 border-gray-200 border-t-gray-900 rounded-full animate-spin"></div>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 gap-4">
          {/* Show first 5 rewards with dynamic data */}
          {REWARDS_DISTRIBUTION_DATA.map((row) => (
            <Reward row={row} dashboardData={dashboardData} key={row.title} />
          ))}
        </div>
      )}
    </div>
  );
};

export default RewardsGridFallback;
